import React from 'react';
import './timeLineChart.css';
import TimelineDataCard from './timeLineDataCard';
import { useDispatch } from 'react-redux';
import { setLifeCalendarPageMenu, setLifeCalendarPagePreviousPragnancy } from '@store/actions/beneficiaryAction';
import { benfTabs } from '@constants/appConstants';
import { benef_life_calendar_const } from '@constants/beneficiaryConstant';

const TimelineEventDetails = ({ timelineEvents }: any) => {

    const dispatch = useDispatch();

    const handlePageNavigation = (eventData: any) => {
        const navigationObject: any = {
            isNavigateFromLifeEvent: true,
            naviGationType: '',
            pregnancyId: '',
            currentServices: false,
            menuItem: '',
            isPreviousPragnancy: false
        };
        if (eventData.pageType === benef_life_calendar_const.pregnancyStatus.registration || eventData.pageType === benef_life_calendar_const.pregnancyStatus.death) {
            navigationObject.menuItem = benfTabs.overview;
        } else if (eventData.pageType === benef_life_calendar_const.pregnancyStatus.family_planning) {
            navigationObject.menuItem = benfTabs.familyPlanning;
        } else if (eventData.pageType === benef_life_calendar_const.pregnancyStatus.abortion || eventData.pageType === benef_life_calendar_const.pregnancyStatus.still_birth || eventData.pageType === benef_life_calendar_const.pregnancyStatus.success) {
            if (!eventData.isPreviousPragnancy) {
                navigationObject.naviGationType = eventData.pageType;
                navigationObject.pregnancyId = eventData.pregnancyId;
                navigationObject.currentServices = eventData.currentServices;
                navigationObject.menuItem = benfTabs.pregnancyServices;
                navigationObject.isPreviousPragnancy = eventData.isPreviousPragnancy;
            } else {
                navigationObject.isPreviousPragnancy = eventData.isPreviousPragnancy;
            }
        } else if (eventData.pageType === benef_life_calendar_const.pregnancyStatus.on_going) {
            navigationObject.naviGationType = eventData.pageType;
            navigationObject.menuItem = benfTabs.pregnancyServices;
        }
        if (!navigationObject.isPreviousPragnancy) {
            dispatch(setLifeCalendarPageMenu(navigationObject));
        } else {
            dispatch(setLifeCalendarPagePreviousPragnancy(navigationObject.isPreviousPragnancy));
        }

    };

    return (
        <>
            {/* Timeline Events Container */}
            <div className='lineCalendarEventContainer' style={{ minWidth: `${(timelineEvents.length - 1) * 160}px` }}>
                {/* Timeline Line */}
                <div className='lineCalendarTimeLine' style={{ width: `${(timelineEvents.length - 1) * 160}px` }}></div>

                {/* event details */}
                {timelineEvents.map((event: any, index: any) => (
                    <div key={index} className='lineCalendarEventContainer'>
                        {/* Event Circle */}
                        <div className='eventCircle' onClick={() => handlePageNavigation(event)}></div>

                        {/* Date Information */}
                        <div className='dateContainer' style={{ transform: event.position === 'top' ? 'translate(-50%, 50%)' : 'translate(-50%, -150%)' }} onClick={() => handlePageNavigation(event)}>
                            <div className='yearText'>{event.year}</div>
                            <div className='monthText'>{event.month}</div>
                        </div>

                        {/* Connecting Line and Data Card */}
                        <TimelineDataCard dataEvent={event} handlePageNavigation={() => handlePageNavigation(event)} />
                    </div>
                ))}
            </div>
        </>
    );
};

export default TimelineEventDetails;